$(".menu-toggler").click(function () {
	$(this).toggleClass("menu-toggler--opened");
	$(".handheld-header__nav-wrapper").toggleClass("menu--opened");
});

$('.handheld-header__nav a[href="#"]').click(function (e) {
	e.preventDefault();
});

$(".handheld-header__nav .menu-item-has-children").append('<button class="toggle-sub-menu"></button>');

$(".handheld-header__nav .toggle-sub-menu").click(function (e) {
	$(this).parent().toggleClass("menu-item--opened");
});